/**
 * Reverse common XML/HTML entity encodings used by bpmn-js when serializing
 * custom moddle attribute values. Order matters: `&amp;` is decoded last so
 * we don't accidentally re-process payloads where a literal `&amp;` represents
 * a real ampersand in the JSON.
 */
export function decodeXmlEntities(s: string): string {
  return s
    .replace(/&#(\d+);/g, (_, num) => String.fromCharCode(parseInt(num, 10)))
    .replace(/&#x([0-9a-fA-F]+);/g, (_, hex) => String.fromCharCode(parseInt(hex, 16)))
    .replace(/&quot;/g, '"')
    .replace(/&apos;/g, "'")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&amp;/g, "&");
}
